/* pnx-recipes.js — shared helpers: mode toggle, saved recipes (local until My Bar lands), formatting. */
(function () {
  var W = window, D = document, LS = null;
  try { LS = W.localStorage; } catch (e) { LS = null; }
  function get(k, d) { try { var v = LS && LS.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  function set(k, v) { try { LS && LS.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---- mode: speakeasy | rave ---- */
  var mode = get('pnx.mode', 'speakeasy');
  D.documentElement.setAttribute('data-pnx-mode', mode);
  function setMode(m) {
    mode = m; D.documentElement.setAttribute('data-pnx-mode', m); set('pnx.mode', m);
    D.querySelectorAll('.pnx-mode__btn').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mode === m)); });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pnx-mode__btn');
    if (b) setMode(b.dataset.mode);
  });
  D.addEventListener('DOMContentLoaded', function () { setMode(mode); });

  /* ---- saved recipes (handles) ---- */
  function saved() { return get('pnx.saved', []); }
  function isSaved(h) { return saved().indexOf(h) !== -1; }
  function toggleSaved(h) {
    var s = saved(), i = s.indexOf(h);
    if (i === -1) s.push(h); else s.splice(i, 1);
    set('pnx.saved', s); return i === -1;
  }

  /* ---- units ---- */
  function fmtOz(n) {
    if (n === 0) return '';
    var r = Math.round(n * 4) / 4; // quarter oz
    var whole = Math.floor(r), frac = r - whole, f = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[frac] || '';
    return (whole ? whole : '') + f || '0';
  }
  function fmtMl(n) { return String(Math.round(n * 29.5735 / 5) * 5); }

  /* ---- account sync (customer metafields via /apps/bar/me; only when window.pnxLoggedIn) ---- */
  var PROXY = W.pnxProxy || '/apps/bar';
  function me() { return fetch(PROXY + '/me', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }); }
  function pullSaved() {
    if (!W.pnxLoggedIn) return Promise.resolve(saved());
    return me().then(function (j) {
      var srv = (j && j.recipes && j.recipes.saved) || [], loc = saved(), changed = false;
      srv.forEach(function (h) { if (loc.indexOf(h) === -1) { loc.push(h); changed = true; } });
      if (changed) set('pnx.saved', loc);
      return loc;
    }).catch(function () { return saved(); });
  }
  function pushSaved() {
    if (!W.pnxLoggedIn) return Promise.resolve(false);
    return me().then(function (j) {
      var rec = (j && j.recipes) || { saved: [], made: [], want: [], strict: false };
      rec.saved = saved();
      return fetch(PROXY + '/me', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ recipes: rec }) }).then(function (r) { return r.ok; });
    }).catch(function () { return false; });
  }

  W.pnxRecipes = { get: get, set: set, saved: saved, isSaved: isSaved, toggleSaved: toggleSaved, pullSaved: pullSaved, pushSaved: pushSaved, fmtOz: fmtOz, fmtMl: fmtMl, setMode: setMode };
})();
